import { render, staticRenderFns } from "./NewsAdmin.vue?vue&type=template&id=0d94e175"
import script from "./NewsAdmin.vue?vue&type=script&lang=js"
export * from "./NewsAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports